module.exports = __webpack_public_path__ + "static/media/it-flowers.9e284da2.svg";